
import PageHeader from '../../../../Components/UI/PageHeader'
import EmploymentDataTable from '../../../../Components/hr/employmenttypes/employmentIndex/employmentDataTable'


const EmpolymentTypes = () => {
  return (
    <div>
      <PageHeader title="Empolyment Types" showButton={true} url={`${process.env.PUBLIC_URL}/empolementtypesstore`}/>
      <EmploymentDataTable/></div>
  )
}

export default EmpolymentTypes